import script from "./QuickLinksTile.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickLinksTile.vue?vue&type=script&setup=true&lang=js"

import "./QuickLinksTile.vue?vue&type=style&index=0&id=1167fb98&lang=scss"

const __exports__ = script;

export default __exports__